const SEPARATOR = ' - ';

export const getTourRateOption = (rate) => {
  const name = (rate && rate.name) || '';
  let depth = 0;
  for (let index = 0; index < name.length; index += 1) {
    const character = name[index];
    if (character === '(') {
      depth += 1;
    } else if (character === ')') {
      depth = Math.max(depth - 1, 0);
    } else if (depth === 0 && name.startsWith(SEPARATOR, index)) {
      return index > 0 ? name.slice(0, index) : null;
    }
  }
  return null;
};

export const getTourRateLabel = (rate) => {
  const name = (rate && rate.name) || '';
  const option = getTourRateOption(rate);
  const label = option ? name.slice(option.length + SEPARATOR.length).trim() : name;
  return label;
};

const getTourOptions = (rates) => {
  const named = (rates || []).map((rate) => getTourRateOption(rate));
  const isSplit = named.length > 0 && named.every(Boolean);
  const options = isSplit ? [...new Set(named)] : [];
  return options;
};

export default getTourOptions;
